
import React, { useEffect, useState } from "react";
import {
  FloatButton,
  Drawer,
  Select,
  DatePicker,
  Button,
  Skeleton,
} from "antd";





import {
  generatedISOFormatDateString,
  roundOffValue,
  roundToTwoDecimalPlaces,
} from "../../../../../../Utils/DateConverstion";
import CustomDrawer from '../../../../../Elements/CustomDrawer';
import CustomSelect from '../../../../../Elements/CustomSelect';
import TreeSelectCustomWithSelectAll from '../../../../Electrical/Charts/LiveModule/LiveTrends/LineChart/TreeSelectCustomWithAllSelect';
import TreeSelectCustom from '../../../../Electrical/Charts/LiveModule/LiveTrends/LineChart/TreeSelectCustom';
import RawGrid from '../../../../../Elements/Grid/Grid';
import ExportToExel from '../../../../../Elements/Grid/Export';
import { useSelector } from "react-redux";
import { useStoreUpdaterWithAPI } from "../../../../../../Hooks/UseStoreUpdaterWithApi";
import { APIConstants } from "../../../../../../Common/APIConstants";
import SteamTreeSelectCustomWithSelectAll from "../../../../../Elements/TreeSelect/TreeSelectCustomWithSelectAll";
import TableComponent from "../../../../../Elements/Grid/TableComponent";



const TempRawDataGrid = () => {
  const {  makeRequest } = useStoreUpdaterWithAPI();
    const [sectionId, setSectionId] = useState();
    const [converterGroupId, setConverterGroupId] = useState(); 
    const [report, setReport] = useState(null)
    const [selectedMeterIds, setSelectedMeterIds] = useState([]);
  const [selectedValues, setSelectedValues] = useState([]);
  const [fromDateObj, setFromDateObj] = useState(null);
  const [fromDateString, setFromDateString] = useState();
  const [toDateObj, setToDateObj] = useState(null);
  const [toDateString, setToDateString] = useState(); 
  const [skip, setSkip] = useState(true);
  const [open, setOpen] = useState(false);
  const [chartSkip, setChartSkip] = useState();
  const [chartInput, setChartInput] = useState();

  const [sectionError, setSectionError] = useState();
  const [converterError, setConverterError] = useState();
  const [meterError, setMeterError] = useState();
  const [paraError, setParaError] = useState();
  const [fromDateError, setFromDateError] = useState();
  const [toDateError, setToDateError] = useState(); 
  const [loading, setLoading] = useState(false); 

  const [flowSectionResData, setflowSectionResData] = useState([]);
  const [getFlowConverterResData, setgetFlowConverterResData] = useState([]);
  const [flowGroupDetailsResData, setflowGroupDetailsResData] = useState([]);
  const [nsGetFlowConverterResData, setnsGetFlowConverterResData] = useState([]);
  const [getFlowSteamGroupMeterResData, setgetFlowSteamGroupMeterResData] = useState([]);

  const [steamRawData,setsteamRawData] = useState([]);
  const [loadings, setLoadings] = useState(true);
  const simulateLoading = (setLoadings) => {
    setLoadings(true);
    setTimeout(() => {
      setLoadings(false);
    }, 2000); // 2 seconds
  };
  useEffect(()=>{
    simulateLoading(setLoadings);
  },[])


  let formattedFromDate; 
  let formattedToDate;

  const showDrawer = () => {
    setOpen(true);
  };

  const onClose = () => {
    setOpen(false);
  };


  useEffect(()=>{
    makeRequest({ 
        type: APIConstants.GET, 
        // GetFlowSteamGropeMeterDetails?GroupID=81
        url: `${APIConstants.GET_FLOW_SECTION_MASTER_DETAILS}`
      }).then((res) => {
        console.log(res)
        setflowSectionResData(res);
      });

    makeRequest({ 
        type: APIConstants.GET, 
        // GetFlowSteamGropeMeterDetails?GroupID=81
        // url: `${APIConstants.GET_FLOW_CONVERTER_DETAILS}`
        url: `${APIConstants.TEMP_GETSITES}` 
      }).then((res) => {
        console.log(res)
        setgetFlowConverterResData(res);
        // setgetFlowConverterResData(dummyResponse);
      });

    makeRequest({  
        type: APIConstants.GET, 
        // GetFlowSteamGropeMeterDetails?GroupID=81
        url: `${APIConstants.GET_STEAM_FLOW_GROUP_DETAILS}`
      }).then((res) => {
        console.log(res)
        setflowGroupDetailsResData(res);
      });

   
  },[]);

  useEffect(()=>{
    makeRequest({ 
        type: APIConstants.GET,  
        // GetFlowSteamGropeMeterDetails?GroupID=81
        url: `${APIConstants.TEMP_METERS_LIST}?SiteID=${converterGroupId}` 
      }).then((res) => {
        console.log(res) 
        setnsGetFlowConverterResData(res);
      });

    makeRequest({ 
        type: APIConstants.GET,  
        // GetFlowSteamGropeMeterDetails?GroupID=81
        url: `${APIConstants.GET_FLOW_STEAM_GROUP_METER_DETAILS}?GroupID=${converterGroupId}` 
      }).then((res) => {
        console.log(res)
        setgetFlowSteamGroupMeterResData(res);
      });
  },[converterGroupId]);



  const getResponse =(inputData)=>{
    console.log(inputData)
    
    makeRequest({
        type: APIConstants.GET,
        // GetFlowSteamGropeMeterDetails?GroupID=81
        // ?SectionID=1&ConverterorGroupID=22&MeterIds=29&FromDate=2024-7-16T12:04:18.000Z&ToDate=2024-7-17T12:04:22.000Z
        url: `${APIConstants.GET_RAWDATA_TEMPERATURE}?SectionID=${inputData.SectionID}&ConverterorGroupID=${inputData.ConverterorGroupID}&MeterIds=${inputData.MeterIds}&FromDate=${inputData.FromDate}&ToDate=${inputData.ToDate}`
      }).then((res) => {
        console.log(res)
        console.log(dummyData) 
        setsteamRawData(res);
      });
  }
  


  const inputData = {
    SectionID: 1,
    ConverterorGroupID: 2,
    MeterIds: "1",
    FromDate: "2023-09-21T07:15:00.000Z",
    ToDate: "2023-09-25T07:15:00.000Z",
  };


  const getFlowSectionList = (flowSectionResData && flowSectionResData) || [];
  const getFlowConverterList =
    (getFlowConverterResData && getFlowConverterResData) || [];
  const flowGroupDetailsList =
    (flowGroupDetailsResData && flowGroupDetailsResData) || [];
  const nsGetFlowConverterList =
    (nsGetFlowConverterResData && nsGetFlowConverterResData) || [];
  const getFlowSteamGroupMeterList =
    (getFlowSteamGroupMeterResData && getFlowSteamGroupMeterResData) || [];

  useEffect(() => {
    // After 1 second, set skipValue to false
    const timeoutId = setTimeout(() => {
      setSkip(false);
    }, 3000);

    // Clear the timeout if the component unmounts or skipValue is set to false
    return () => clearTimeout(timeoutId);
  }, []);

  const handleChangeSection = (changedValues) => {
    setSectionId(changedValues);
    setSelectedMeterIds();
    if (changedValues) {
      setSectionError("");
    }
  };

  const handleChangeConverterGroup = (changedValues) => {
    setConverterGroupId(changedValues);
    setSelectedMeterIds();
    if (changedValues) {
      setConverterError("");
    }
  };

  const handleMeterChange = (selectedValues) => {
    setSelectedMeterIds(selectedValues);
    if (selectedValues) {
      setMeterError("");
    }
  };

  const handleTreeChange = (values) => {
    setSelectedValues(values);
    if (values) {
      setParaError("");
    }
  };

  const onChangeFromDate = (date, dateString) => {
    setFromDateString(dateString);
    setFromDateObj(date);
    if (dateString) {
      setFromDateError("");
    }
  };

  const onChangeToDate = (date, dateString) => {
    setToDateString(dateString);
    setToDateObj(date);
    if (dateString) {
      setToDateError("");
    }
  };

  const setChartInputData = () => {
    // const [date, time] =  fromDateString?.split("T")
    // const [toDateSplit, toTimeSplit] =toDateString?.split("T")
    const fromDateTimeStamp = fromDateString;

    const fromDate = new Date(fromDateString || new Date());
    const toDate = new Date(toDateString || new Date());

    const fromHours = fromDate.getUTCHours();
    const fromMinutes = fromDate.getUTCMinutes();
    const fromSeconds = fromDate.getUTCSeconds();

    const toHours = toDate.getUTCHours();
    const toMinutes = toDate.getUTCMinutes();
    const toSeconds = toDate.getUTCSeconds();

    // const [fromHours, fromMinutes, fromSeconds] = time?.split(":").map(Number);
    // const [toHours, toMinutes, toseconds] = toTimeSplit?.split(":").map(Number);

    // Set the UTC hours, minutes, and seconds
    fromDate.setUTCHours(fromHours);
    fromDate.setUTCMinutes(fromMinutes);
    fromDate.setUTCSeconds(fromSeconds);

    toDate.setUTCHours(toHours);
    toDate.setUTCMinutes(toMinutes);
    toDate.setUTCSeconds(toSeconds);

    formattedFromDate = generatedISOFormatDateString(fromDate);
    formattedToDate = generatedISOFormatDateString(toDate);

    const ids = selectedMeterIds?.map((id) => id).join(",");
    const inputData = {
      SectionID: Number(sectionId) || 1,
      ConverterorGroupID: Number(converterGroupId) || 2,
      MeterIds: ids || 1,
      FromDate: formattedFromDate || "2023-09-21 07:15:00.000",
      ToDate: formattedToDate || "2023-09-25 07:15:00.000",
    };
    // const queryString = objectToQueryString(inputData);
    // setChartInput(queryString);
    getResponse(inputData)
  };

  useEffect(() => {
    setChartInputData();
  }, []);

  const parameters = [
    { id: 1, name: "rh" },
    { id: 2, name: "temperature" },
  ];

  useEffect(() => {
    setChartSkip(false);
    updateChart();
  }, [chartInput, steamRawData, selectedValues]);

  const validateInput = (value, label) => {
    const error = !value ? `Please Select ${label}` : "";
    return error;
  };

  const handleSubmit = () => {
    const sectionError = validateInput(sectionId, "Section");
    const converterError = validateInput(converterGroupId, "Converter");
    const meterError = validateInput(selectedMeterIds.length, "Meter");
    const paraError = validateInput(selectedValues.length, "Parameter");
    const fromDateError = validateInput(fromDateString, "From Date");
    const toDateError = validateInput(toDateString, "To Date");

    setSectionError(sectionError);
    setConverterError(converterError);
    setMeterError(meterError);
    setParaError(paraError);
    setFromDateError(fromDateError);
    setToDateError(toDateError);

    if (
      !sectionError &&
      !converterError &&
      !meterError &&
      !paraError &&
      !fromDateError &&
      !toDateError
    ) {
      onClose();
      setChartInputData();
    }
  };

  const findMaxMeter = (array) => {
    let maxMeter = array[0]?.name;
    let maxLength = array[0]?.data?.length;

    array?.forEach((arr) => {
      const currentLength = arr.data.length;

      if (currentLength > maxLength) {
        maxLength = currentLength;
        maxMeter = arr.name;
      }
    });
    return maxMeter;
  };

  const maxDates = (name, data, value) => {
    const modifiedString = name?.replace(/-temperature|-rh/g, "");
    const filteredData = data?.filter((d) => d[value] === modifiedString);
    if (filteredData?.length === 0) {
      return;
    }
    const dates = filteredData?.map((d) => d.createdON);
    return dates;
  };

  const bindData = (datesArray, data) => {
    const resultArray = [];
    datesArray?.forEach((date, index) => {
      const dataObject = { date: new Date(date).toLocaleString() };

      data?.forEach((item) => {
        if (item.data[index] >= 0) {
          dataObject[item.name] = item.data[index];
        } else {
          dataObject[item.name] = "-";
        }
      });

      resultArray.push(dataObject);
    });
    return resultArray;
  };

  const updateChart = async () => {
    console.log(steamRawData)
    try {
      const selectedMeterData = steamRawData?.filter((item) =>
        selectedMeterIds?.map((id) => Number(id)).includes(item?.meterid)
      );
      const firstOption = selectedValues.includes("rh");
      const secondOption = selectedValues.includes("temperature");
      selectedMeterData?.sort(
        (a, b) => new Date(a.createdON) - new Date(b.createdON)
      );

      console.log(selectedMeterIds)
      const transformData = (property, meterName) => {
        console.log(selectedMeterData)
        const data = selectedMeterData
          ?.filter((item) => item?.metername === meterName)
          ?.map((item) => item[property]);
        const seriesData = {
          name: `${meterName}-${property}`, // Concatenate property and METERNAME
          data,
        };
        return seriesData;
      };

      console.log(nsGetFlowConverterList)
      console.log(selectedMeterIds)
      const properties = selectedValues;
      const seriesData = [];
      selectedMeterIds?.forEach((id) => {
        const meterName = 
          sectionId === 1 
            ? nsGetFlowConverterList?.find(
                (item) => item?.meteR_METERID === Number(id)
              ).metername
            : getFlowSteamGroupMeterList?.find(
                (item) => item?.meterID === Number(id)
              ).meterName;
        properties.forEach((property) => {
          seriesData.push(transformData(property, meterName));
        });

      });
      console.log(seriesData)

      const maxCountMeter = findMaxMeter(seriesData);

      const maxDatesArray = maxDates(
        maxCountMeter,
        selectedMeterData,
        sectionId === 1 ? "metername"
         :
         "metername"
      );
      const tableData = bindData(maxDatesArray, seriesData);

      // Iterate over the map and create the transformed data
      tableData.forEach(({ metername, temperature, rh }, createdON) => {
        // Check if the date already exists in the tableData
        const date = new Date(createdON).setMilliseconds(0);
        const existingRow = tableData.find(
          (row) => row.date === new Date(date)
          .toLocaleString()
        );

        if (existingRow) {
          // If the date exists, update the existing entry with new values
          existingRow[`${metername}-temperature`] = temperature;
          existingRow[`${metername}-rh`] = rh;
          existingRow[`${metername}`] =
            temperature > rh ? temperature : rh;
        } else {
          // If the date doesn't exist, create a new entry
          const newRow = {
            date: new Date(date).toLocaleString(),
            [`${metername}-temperature`]: temperature,
            [`${metername}-rh`]: rh,
            [`${metername}`]: temperature > rh ? temperature : rh,
          };
          tableData.push(newRow);
        }
      });
    //   console.log(tableData.pop())
    tableData.pop()
 
      setReport(tableData);
    } catch (err) {
      console.log(err);
    }
  };

  const selectedMeters = () => {
    console.log(nsGetFlowConverterList)
    const meters = selectedMeterIds?.map((id) => {
      const meter =
        sectionId === 1
          ? nsGetFlowConverterList?.find((meter) => meter.meteR_METERID === id)
              ?.metername
          : getFlowSteamGroupMeterList?.find((meter) => meter.meterID === id)
              ?.meterName;
      return meter || ""; // Return an empty string if the meter is not found
    });
    const allmeters = [];
    const firstOption = selectedValues.includes("rh");
    const secondOption = selectedValues.includes("temperature");
    meters?.forEach((meter) => {
      if (firstOption && secondOption) {
        allmeters.push(meter + "-rh");
        allmeters.push(meter + "-temperature");
      } else if (firstOption) {
        allmeters.push(meter + "-rh");
      } else {
        allmeters.push(meter + "-temperature");
      }
    });

    return allmeters;
  };

    const mode = useSelector((state) => state.darkMode);

    const { isdarkMode } = mode;
    console.log(selectedMeters()) 
    console.log(report)

    function getDDMMYYYY() {
        let today = new Date();
        
        let dd = String(today.getDate()).padStart(2, '0');
        let mm = String(today.getMonth() + 1).padStart(2, '0'); // January is 0!
        let yyyy = today.getFullYear();
        
        return dd + '_' + mm + '_' + yyyy;
    }

  return (
    <div className="rounded-md w-auto">
    {/* {isMeterDataDetailsLoading && ( */}
      <>
        {/* <Skeleton active paragraph={{ rows: 20 }} className="mt-12 mx-3" /> */}
      </>
    {/* )} */}
    {/* {loading && ( */}
      <>
        {/* <Skeleton active paragraph={{ rows: 20 }} className="mt-12 mx-3" /> */}
      </> 
    {/* )} */}
    {/* <div className="flex justify-center">
      {isMeterDataDetailsError && 
      (
        <div className="flex flex-col">
          <img className="w-[150px] h-[80px] " src={errorNew} />
          <p className="text-sm text-red-500 text-center">Server error</p>
          <p className="text-center">Please reload the page</p>
        </div>
      )}
    </div> */}
 
    <div className="my-2 flex justify-end mr-2">
      {report?.length > 0 && (
        <ExportToExel
          report={report}
          meters={selectedMeters()}
          parameter={selectedValues?.length === 2}
          filename={getDDMMYYYY()}
        /> 
       )} 
    </div>

   
   {
    !loadings? 
      <div className={`m-2`}> 
        <TableComponent
         report={report} 
         meters={selectedMeters()}
         parameter={selectedValues.length === 2}  
        />
      </div>:
       <>
       <Skeleton active paragraph={{ rows: 6 }} />
     </> 
   }


    <CustomDrawer
        title="Close"
        showDrawer={showDrawer}
        open={open}
        onClose={onClose}
      >
        <div className="flex flex-col space-y-2">
          <CustomSelect
            label="Section:"
            options={getFlowSectionList}
            onSelect={handleChangeSection}
            valueKey="sectionID"
            nameKey="sectionName"
            
          />
          <small className="text-red-500 font-bold ml-[150px]">
            {sectionError}
          </small>
          <CustomSelect
            label="Converter / Group:"
            options={
              sectionId === 1 ? getFlowConverterList : flowGroupDetailsList
            }
            onSelect={handleChangeConverterGroup}
            valueKey={sectionId === 1 ? "sitE_ID" : "groupID"}
            nameKey={sectionId === 1 ? "sitename" : "groupName"}
          />
          <small className="text-red-500 font-bold ml-[150px]">
            {converterError}
          </small>
          <SteamTreeSelectCustomWithSelectAll
            label="Meters:"
            data={
              sectionId === 1
                ? nsGetFlowConverterList
                : getFlowSteamGroupMeterList
            }
            idKey={sectionId === 1 ? "meteR_METERID" : "meteR_METERID"}
            valueKey={sectionId === 1 ? "meteR_METERID" : "meteR_METERID"}
            nameKey={sectionId === 1 ? "metername" : "meterName"}
            selectedValues={selectedMeterIds}
            setSelectedValues={setSelectedMeterIds}
            onSelect={handleMeterChange}
          />
          <small className="text-red-500 font-bold ml-[150px]">
            {meterError}
          </small>
          <TreeSelectCustom
            label="Parameters:"
            data={parameters}
            idKey="id"
            nameKey="name"
            valueKey="name"
            selectedValues={selectedValues}
            setSelectedValues={setSelectedValues}
            onSelect={handleTreeChange}
          />
          <small className="text-red-500 font-bold ml-[150px]">
            {paraError}
          </small>
          <div className="mt-2 flex">
            <label className="pr-3 w-32  text-left">From Date:</label>
            <DatePicker
              value={fromDateObj}
              onChange={onChangeFromDate}
              className={`   ${isdarkMode ? 'datebackground dateplaceholder ' : 'whitemode'} w-80 `}
              dropdownClassName={isdarkMode ? 'datedropdown' : 'whitemode'}
              showTime={{ format: "HH:mm:ss" }}
              format="YYYY-MM-DD HH:mm:ss"
            />
          </div>
          <small className="text-red-500 font-bold ml-[150px]">
            {fromDateError}
          </small>
          <div className="mt-2 flex">
            <label className="pr-3 w-32 text-left">To Date:</label>
            <DatePicker
              value={toDateObj}
              onChange={onChangeToDate}
              className={`  ${isdarkMode ? 'datebackground dateplaceholder' : 'whitemode'} w-80 `}
              dropdownClassName={isdarkMode ? 'datedropdown' : 'whitemode'}
              showTime={{ format: "HH:mm:ss" }}
              format="YYYY-MM-DD HH:mm:ss"
            />
          </div>
          <small className="text-red-500 font-bold ml-[150px]">
            {toDateError}
          </small>
        </div>
        <div className="flex justify-center mt-4">
          <Button
            className="blue-btn"
            onClick={() => {
              handleSubmit();
            }}
          >
            Search
          </Button>
        </div>
      </CustomDrawer>
  </div>
  )
}

export default TempRawDataGrid
